module.exports = "//static.hsappstatic.net/growth-onboarding-confetti/static-1.927/images/sprocket.svg"